export default __webpack_public_path__ + "static/media/pinterest-hover.5e74d796.svg";